import { SelectFilterOption } from './SelectFilterOption'

export const areOptionsOfEqualValue = (
  a: SelectFilterOption,
  b: SelectFilterOption
) => a && b && a.value === b.value
